export default "__VITE_ASSET__e7bd870f__"